import React, { useEffect } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';

export const OptumId = () => {
  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <TextInput
        label="OptumID"
        model="searchDraft.optumId"
        required
        id="optumId-textinput"
        aria-label="Type here to Enter a OptumID "
        styles={{
          subText: (base) => {
            return {
              ...base,
              fontSize: '14px',
              fontStyle: 'italic',
              lineHeight: '18px',
              paddingLeft: '3px',
              paddingTop: '3px',
            };
          },
        }}
        validators={{
          required: (value) => {
            return !value ? 'OptumId is required.' : '';
          },
          spaceInTin: (value) => {
            return value.includes(' ')
              ? 'OptumId is invalid. Please remove spaces.'
              : '';
          },
        }}
        isClearable
        autoComplete="off"
      />
    </React.Fragment>
  );
};

OptumId.propTypes = {};

OptumId.defaultProps = {};
